import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NewsletterBanner from "../newsletter/NewsletterBanner";

const Footer: React.FC = () => {
  const { t, i18n } = useTranslation();
  const langPrefix = `/${i18n.language}`;
  const [showNewsletterModal, setShowNewsletterModal] = useState(false);

  const colors = {
    background: "bg-vett-pale-green", 
    textDark: "text-vett-dark-green",
    textSoft: "text-vett-soft-gray",
    textHover: "hover:text-vett-dark-green",
    border: "border-vett-turquoise",
  };

  return (
    <footer className={`${colors.background} py-12 md:py-16`}>
      {" "}
      {/* Aumenta padding en pantallas medianas+ */}
      <div className="container mx-auto px-6 md:px-8">
        {" "}
        {/* Ajusta padding horizontal */}
        {/* --- Contenido Principal del Footer --- */}
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10 lg:gap-y-0`}
        >
          {" "}
          {/* Responsive Grid */}
          {/* Columna 1: Marca */}
          <div className="text-center sm:text-left">
            {" "}
            {/* Centrado en móvil, izquierda en sm+ */}
            <div className="flex justify-center sm:justify-start mb-4">
              <img
                src="/images/logo/LogoVettConsultBlanco.webp"
                alt="VettConsult Logo"
                className="h-12 w-auto"
              />
            </div>
            <h3 className={`font-display ${colors.textDark} text-xl mb-4`}>
              {t("common.appName")}
            </h3>
            <p className={`${colors.textSoft} text-sm md:text-base`}>
              {" "}
              {/* Ajusta tamaño de fuente */}
              {t("footer.description")}
            </p>
          </div>
          {/* Columna 2: Quick Links */}
          <div className="text-center sm:text-left">
            <h4 className={`font-bold mb-4 ${colors.textDark}`}>{t("footer.quickLinks")}</h4>
            <nav className="space-y-2">
              <Link
                to={langPrefix}
                className={`block ${colors.textSoft} ${colors.textHover} text-sm md:text-base`}
              >
                {t("navbar.home")}
              </Link>
              <Link
                to={`${langPrefix}/services`}
                className={`block ${colors.textSoft} ${colors.textHover} text-sm md:text-base`}
              >
                {t("navbar.services")}
              </Link>
              <Link
                to={`${langPrefix}/pricing`}
                className={`block ${colors.textSoft} ${colors.textHover} text-sm md:text-base`}
              >
                {t("navbar.pricing")}
              </Link>
              {/* About Us link removed from footer per request - kept here for reference
              <Link
                to={`${langPrefix}/about`}
                className={`block ${colors.textSoft} ${colors.textHover} text-sm md:text-base`}
              >
                {t("navbar.about")}
              </Link>
              */}
              {/* NEWSLETTER LINK */}
              <button
                onClick={() => setShowNewsletterModal(true)}
                className={`block w-full text-center sm:text-left ${colors.textSoft} ${colors.textHover} text-sm md:text-base transition-colors duration-200 outline-none focus:outline-none`}
              >
                {t("footer.newsletter", "Newsletter")}
              </button>
            </nav>
          </div>
          {/* Columna 3: Legal */}
          <div className="text-center sm:text-left">
            <h4 className={`font-bold mb-4 ${colors.textDark}`}>{t("footer.legal")}</h4>
            <nav className="space-y-2">
              <Link
                to={`${langPrefix}/privacy-policy`}
                className={`block ${colors.textSoft} ${colors.textHover} text-sm md:text-base`}
              >
                {t("security.title")}
              </Link>

              <Link
                to={`${langPrefix}/terms`}
                className={`block ${colors.textSoft} ${colors.textHover} text-sm md:text-base`}
              >
                {t("terms.title")}
              </Link>
            </nav>
          </div>
          {/* Columna 4: Contact */}
          <div className="text-center sm:text-left">
            <h4 className={`font-bold mb-4 ${colors.textDark}`}>{t("footer.contact")}</h4>
            <p
              className={`${colors.textSoft} text-sm md:text-base leading-relaxed`}
            >
              {" "}
              {/* Mejor interlineado */}
              Email: vettconsult@hotmail.com
            </p>
            {/* Aquí podrías añadir iconos de redes sociales si quisieras */}
          </div>
        </div>
        {/* --- Copyright --- */}
        <div
          className={`container mx-auto px-4 mt-10 md:mt-12 pt-6 md:pt-8 border-t ${colors.border} text-center`}
        >
          {" "}
          {/* Ajusta márgenes/padding */}
          <p className={`${colors.textSoft} text-xs md:text-sm mb-2`}>
            {" "}
            {/* Ajusta tamaño de fuente */}
            {t("footer.copyright")}
          </p>
          <p className={`${colors.textSoft} text-xs md:text-sm`}>
            designed & crafted with ❤️ by{" "}
            <a
              href="https://becr3ative.com"
              target="_blank"
              rel="noopener noreferrer"
              className={`${colors.textHover} font-medium underline transition-colors`}
            >
              be creative
            </a>
          </p>
        </div>
      </div>

      {/* Newsletter Modal */}
      {showNewsletterModal && (
        <NewsletterBanner 
          variant="modal" 
          onClose={() => setShowNewsletterModal(false)}
          showCloseButton={true} 
        />
      )}
    </footer>
  );
};

export default Footer;
